import { Component } from 'react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary] Caught error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div style={{
          padding: 24,
          textAlign: 'center',
          color: '#666',
          fontSize: 13,
          background: 'var(--card, #fff)',
          borderRadius: 8,
          margin: 16,
          border: '1px solid #eee',
        }}>
          <div style={{ fontSize: 24, marginBottom: 8 }}>⚠️</div>
          <div style={{ fontWeight: 600, marginBottom: 4 }}>Something went wrong here</div>
          <div>Please refresh the page to try again.</div>
        </div>
      );
    }
    return this.props.children;
  }
}
